import { createMappingWarning, parseAmount } from "../utils.js";
export function mapDuoToLiabilities(duo, customerId) {
    const errors = [];
    const warnings = [];
    const sections = {};
    if (duo.debtRemainingAmount && duo.debtRemainingAmount > 0) {
        const studentDebtType = "studentDebtSF35";
        let endDate;
        if (duo.debtRemainingMonthsToRepay && duo.debtRemainingMonthsToRepay > 0) {
            const currentDate = new Date();
            currentDate.setMonth(currentDate.getMonth() + duo.debtRemainingMonthsToRepay);
            endDate = currentDate.toISOString().split("T")[0];
        }
        const studentDebt = {
            originalDebt: parseAmount(duo.debtStartingAmount),
            currentDebt: parseAmount(duo.debtRemainingAmount),
            remainingMonths: duo.debtRemainingMonthsToRepay ?? undefined,
            endDate,
            interestRate: parseAmount(duo.debtCurrentInterestRate),
            settledForNewMortgage: false,
        };
        sections[studentDebtType] = [
            {
                id: `student-debt-${globalThis.crypto.randomUUID()}`,
                sectionKey: studentDebtType,
                values: studentDebt,
            },
        ];
        // Add warning if debt is paused
        if (duo.debtPauseMonthsRemaining > 0) {
            warnings.push(createMappingWarning("duo.debtPauseMonthsRemaining", `Student debt repayment is paused for ${duo.debtPauseMonthsRemaining} months`, duo.debtPauseMonthsRemaining));
        }
        // Add warning if some debt information is missing
        if (!duo.debtStartingAmount) {
            warnings.push(createMappingWarning("duo.debtStartingAmount", "Original debt amount is not available", duo.debtStartingAmount));
        }
        if (!duo.debtCurrentInterestRate) {
            warnings.push(createMappingWarning("duo.debtCurrentInterestRate", "Current interest rate is not available", duo.debtCurrentInterestRate));
        }
    }
    const liabilities = {
        customerId,
        sections,
    };
    return { liabilities, errors, warnings };
}
